import styled from 'styled-components';
import { fontFamilyRegular } from './Fonts';

export const Form = styled.form`
  ${fontFamilyRegular};

  fieldset {
    margin: 0;
    padding: 0;
  }
`;

export const FormActions = styled.div`
  display: flex;
  padding: 1.25rem;
  button {
    width: 100%;
  }
`;
